import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import logoLight from "assets/images/logo-light.png";
import logoDark from "assets/images/logo-dark.png";
import { useTranslation } from "react-i18next";
import { formatTime } from "helpers/functionsHelpers";
import { useTimer } from "hooks";
import { Loader2 } from "lucide-react";

interface OtpViewProps {
  formik: any;
  resendOtp: () => void;
}

export const OtpView: React.FC<OtpViewProps> = ({ formik, resendOtp }) => {
  const { t } = useTranslation();

  const { timeLeft, setTimeLeft } = useTimer(120);

  useEffect(() => {
    const bodyElement = document.body;

    bodyElement.classList.add(
      "flex",
      "items-center",
      "justify-center",
      "min-h-screen",
      "py-16",
      "lg:py-10",
      "bg-slate-50",
      "dark:bg-zink-800",
      "dark:text-zink-100",
      "font-public"
    );

    return () => {
      bodyElement.classList.remove(
        "flex",
        "items-center",
        "justify-center",
        "min-h-screen",
        "py-16",
        "lg:py-10",
        "bg-slate-50",
        "dark:bg-zink-800",
        "dark:text-zink-100",
        "font-public"
      );
    };
  }, []);

  return (
    <React.Fragment>
      <div className="relative pt-14 h-full">
        {/* <AuthIcon /> */}

        <div className="mb-0 w-screen lg:w-[500px] card shadow-lg border-none shadow-slate-100 dark:shadow-zink-500/20 relative">
          <div className="!px-10 !py-12 card-body">
            <Link to="#">
              <img
                src={logoLight}
                alt=""
                className="hidden h-6 mx-auto dark:block"
              />
              <img
                src={logoDark}
                alt=""
                className="block h-6 mx-auto dark:hidden"
              />
            </Link>

            <div className="mt-8 text-center">
              <h4 className="mb-2 text-custom-500 dark:text-custom-500">
                {t("OtpValidation.title")}
              </h4>
              <p className="mb-8 text-slate-500 dark:text-zink-200">
                {t("OtpValidation.disclaimer")}
              </p>
            </div>

            <form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
              }}
            >
              <div className="!grid !grid-cols-1 gap-2 md:!grid-cols-4">
                <div>
                  <label htmlFor="digit1-input" className="hidden">
                    Digit 1
                  </label>
                  <input
                    type="text"
                    className="text-lg text-center form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    required
                    placeholder="0"
                    // onKeyUp="moveToNext(1, event)"
                    maxLength={1}
                    id="digit1-input"
                    onChange={({ target: { value } }) => {
                      formik.setFieldValue("code1", value);
                    }}
                  />
                </div>
                <div>
                  <label htmlFor="digit2-input" className="hidden">
                    Digit 2
                  </label>
                  <input
                    type="text"
                    className="text-lg text-center form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    required
                    placeholder="0"
                    // onKeyUp="moveToNext(2, event)"
                    maxLength={1}
                    id="digit2-input"
                    onChange={({ target: { value } }) => {
                      formik.setFieldValue("code2", value);
                    }}
                  />
                </div>

                <div>
                  <label htmlFor="digit3-input" className="hidden">
                    Digit 3
                  </label>
                  <input
                    type="text"
                    className="text-lg text-center form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    required
                    placeholder="0"
                    // onKeyUp="moveToNext(3, event)"
                    maxLength={1}
                    id="digit3-input"
                    onChange={({ target: { value } }) => {
                      formik.setFieldValue("code3", value);
                    }}
                  />
                </div>

                <div>
                  <label htmlFor="digit4-input" className="hidden">
                    Digit 4
                  </label>
                  <input
                    type="text"
                    className="text-lg text-center form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    required
                    placeholder="0"
                    // onKeyUp="moveToNext(4, event)"
                    maxLength={1}
                    id="digit4-input"
                    onChange={({ target: { value } }) => {
                      formik.setFieldValue("code4", value);
                    }}
                  />
                </div>
              </div>
              <div className=" w-full flex items-center justify-center mt-10">
                <button
                  type="button"
                  className={
                    "text-sm w-40 text-center " +
                    (timeLeft === 0 ? "text-custom-500" : "text-slate-500")
                  }
                  disabled={timeLeft !== 0}
                  onClick={(e) => {
                    e.preventDefault();
                    if (timeLeft === 0) {
                      resendOtp();
                      setTimeLeft(120);
                    }
                  }}
                >
                  {t("OtpValidation.resendOtp") + " " + formatTime(timeLeft)}
                </button>
              </div>
              <div className="mt-10">
                <button
                  type="submit"
                  className="w-full flex flex-row justify-center text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  disabled={formik.isSubmitting}
                >
                  {formik.isSubmitting ? (
                    <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                  ) : null}
                  {t("OtpValidation.btnVerify")}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
